module.exports = __webpack_public_path__ + "static/media/filter.bd9f3f12.svg";